import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false, speed: 300, minimum: 0.15, trickleSpeed: 120 });

export function TopLoader() {
  const location = useLocation();

  useEffect(() => {
    NProgress.start();
    const t = setTimeout(() => NProgress.done(), 150);
    return () => { clearTimeout(t); NProgress.done(); };
  }, [location.pathname]);

  return null;
}
